"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewMatrixComponent = exports.OverviewCategoriesAndTagsComponent = exports.OverviewOwnershipListComponent = exports.OverviewValueAtRiskListComponent = exports.OverviewBarPlotListComponent = exports.OverviewStatusListComponent = void 0;
var React = require("react");
var iterUtils_1 = require("../lib/iterUtils");
var App_1 = require("../../App");
var mobx_react_1 = require("mobx-react");
var container_1 = require("./container");
var statusTab_1 = require("./statusTab");
var barplotsTab_1 = require("./barplotsTab");
var valueatriskTab_1 = require("./valueatriskTab");
var ownershipTab_1 = require("./ownershipTab");
var tagsTab_1 = require("./tagsTab");
var matrixtab_1 = require("./matrixtab");
var OverviewStatusListComponent = (function (_super) {
    __extends(OverviewStatusListComponent, _super);
    function OverviewStatusListComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewStatusListComponent.prototype.render = function () {
        var statuses = this.props.statuses;
        var todos = this.props.todos;
        var parts = [];
        if (!statuses || !todos) {
            parts.push(React.createElement("div", null, gettext("No data")));
        }
        else {
            var i = new iterUtils_1.Counter();
            parts.push(this.renderChart(i, statuses.risks, todos.risks));
            parts.push(this.renderChart(i, statuses.controls, todos.controls, get_term("Possible, Planned and Ongoing Controls")));
            parts.push(this.renderChart(i, statuses.actions, todos.actions, gettext("Possible, Planned and Ongoing Actions")));
            parts.push(this.renderChart(i, statuses.causes, todos.causes));
            parts.push(this.renderChart(i, statuses.effects, todos.effects));
        }
        return (React.createElement("div", { className: "OverviewStatus" },
            React.createElement(App_1.LoadingSpinner, { loading: this.props.isLoading, size: 10, className: "mt-5 pt-5" }, parts)));
    };
    OverviewStatusListComponent.prototype.renderChart = function (keyCounter, statuses, todos, subtitle) {
        if (!statuses || !todos || statuses.length == 0 || todos.length == 0) {
            return React.createElement("div", null, gettext("No data"));
        }
        else {
            return (React.createElement(React.Fragment, null, statuses.map(function (status, i) {
                return React.createElement(container_1.Container, { fullWidth: true, containerTitle: status.key, key: keyCounter.increment() },
                    React.createElement(statusTab_1.OverviewStatusContainer, { values: status.values, key: keyCounter.increment(), title: status.key }),
                    React.createElement(statusTab_1.OverviewTodoContainer, { values: todos[i].values, title: todos[i].key, subtitle: subtitle, key: keyCounter.increment() }));
            })));
        }
    };
    OverviewStatusListComponent = __decorate([
        mobx_react_1.observer
    ], OverviewStatusListComponent);
    return OverviewStatusListComponent;
}(React.Component));
exports.OverviewStatusListComponent = OverviewStatusListComponent;
var OverviewBarPlotListComponent = (function (_super) {
    __extends(OverviewBarPlotListComponent, _super);
    function OverviewBarPlotListComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewBarPlotListComponent.prototype.render = function () {
        var data = this.props.data;
        var parts = [];
        if (data && (data.risks || data.opportunities)) {
            parts.push(React.createElement(barplotsTab_1.OverviewBarPlotsContainer, { eval_types: this.props.eval_types, values: data }));
        }
        else {
            parts.push(React.createElement("div", null, gettext("No data")));
        }
        return (React.createElement("div", { className: "OverviewBarplot" },
            React.createElement(App_1.LoadingSpinner, { loading: this.props.isLoading, size: 10, className: "mt-5 pt-5" }, parts)));
    };
    OverviewBarPlotListComponent = __decorate([
        mobx_react_1.observer
    ], OverviewBarPlotListComponent);
    return OverviewBarPlotListComponent;
}(React.Component));
exports.OverviewBarPlotListComponent = OverviewBarPlotListComponent;
var OverviewValueAtRiskListComponent = (function (_super) {
    __extends(OverviewValueAtRiskListComponent, _super);
    function OverviewValueAtRiskListComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewValueAtRiskListComponent.prototype.render = function () {
        var _this = this;
        var data = this.props.data;
        var parts = [];
        if (data && data.length > 0) {
            data.map(function (value) {
                parts.push(React.createElement(valueatriskTab_1.OverviewValueAtRiskContainer, { data: value, number_to_show: _this.props.number_to_show, eval_types: _this.props.eval_types, include_cost: _this.props.include_costs }));
            });
        }
        else {
            parts.push(React.createElement("div", null, gettext("No data")));
        }
        return (React.createElement("div", { className: "OverviewValueAtRisk" },
            React.createElement(App_1.LoadingSpinner, { loading: this.props.isLoading, size: 10, className: "mt-5 pt-5" }, parts)));
    };
    OverviewValueAtRiskListComponent = __decorate([
        mobx_react_1.observer
    ], OverviewValueAtRiskListComponent);
    return OverviewValueAtRiskListComponent;
}(React.Component));
exports.OverviewValueAtRiskListComponent = OverviewValueAtRiskListComponent;
var OverviewOwnershipListComponent = (function (_super) {
    __extends(OverviewOwnershipListComponent, _super);
    function OverviewOwnershipListComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewOwnershipListComponent.prototype.render = function () {
        return (React.createElement("div", { className: "OverviewOwnership" },
            React.createElement(App_1.LoadingSpinner, { loading: this.props.isLoading, size: 10, className: "mt-5 pt-5" },
                React.createElement(container_1.Container, { fullWidth: true, containerTitle: gettext("Ownership Statistics") },
                    React.createElement(ownershipTab_1.OverviewOwnershipContainer, { data: this.props.data })))));
    };
    OverviewOwnershipListComponent = __decorate([
        mobx_react_1.observer
    ], OverviewOwnershipListComponent);
    return OverviewOwnershipListComponent;
}(React.Component));
exports.OverviewOwnershipListComponent = OverviewOwnershipListComponent;
var OverviewCategoriesAndTagsComponent = (function (_super) {
    __extends(OverviewCategoriesAndTagsComponent, _super);
    function OverviewCategoriesAndTagsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewCategoriesAndTagsComponent.prototype.render = function () {
        var data = this.props.data;
        var parts = [];
        if (!data) {
            parts.push(React.createElement("div", null, gettext("No data")));
        }
        else {
            var i = new iterUtils_1.Counter();
            parts.push(this.renderCategories(data.risks, get_term("Risks"), i));
            parts.push(this.renderCategories(data.controls, get_term("Controls"), i));
            parts.push(this.renderCategories(data.actions, gettext("Actions"), i));
        }
        return (React.createElement("div", { className: "OverviewCategoriesAndTags" },
            React.createElement(App_1.LoadingSpinner, { loading: this.props.isLoading, size: 10, className: "mt-5 pt-5" }, parts)));
    };
    OverviewCategoriesAndTagsComponent.prototype.renderCategories = function (categories, title, keyCounter) {
        return (React.createElement(container_1.Container, { fullWidth: true, containerTitle: title, key: keyCounter.increment() }, categories.length == 0 ?
            React.createElement("div", null, gettext("No data"))
            :
                categories.map(function (category) {
                    return React.createElement(tagsTab_1.OverviewTagsContainer, { category: category, key: keyCounter.increment(), title: title });
                })));
    };
    OverviewCategoriesAndTagsComponent = __decorate([
        mobx_react_1.observer
    ], OverviewCategoriesAndTagsComponent);
    return OverviewCategoriesAndTagsComponent;
}(React.Component));
exports.OverviewCategoriesAndTagsComponent = OverviewCategoriesAndTagsComponent;
var OverviewMatrixComponent = (function (_super) {
    __extends(OverviewMatrixComponent, _super);
    function OverviewMatrixComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewMatrixComponent.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var matrices = props.data;
        var selected_definitions = props.selected_definitions;
        if (matrices.length == 0)
            return React.createElement("div", null, gettext("No data"));
        var elements = matrices.map(function (matrix, index) {
            var selected_definition = 0;
            selected_definitions.forEach(function (value, key) {
                if (key == index) {
                    selected_definition = value;
                }
            });
            return (React.createElement(matrixtab_1.OverviewMatrixContainer, { eval_types: _this.props.eval_types, number_to_show: _this.props.number_to_show, selected_definition: selected_definition, matrix: matrix, useQuantitative: _this.props.useQuantitative, showValues: _this.props.showValues, key: index }));
        });
        return (React.createElement("div", { className: "OverviewMatrix" },
            React.createElement(App_1.LoadingSpinner, { loading: this.props.isLoading, size: 10, className: "mt-5 pt-5" }, elements)));
    };
    OverviewMatrixComponent = __decorate([
        mobx_react_1.observer
    ], OverviewMatrixComponent);
    return OverviewMatrixComponent;
}(React.Component));
exports.OverviewMatrixComponent = OverviewMatrixComponent;
